export class ProveedorTagXML {
   proveedorTagXmlId: string;
   proveedorId: string;
   emisorId: string;
   nombre: string;
   xmlTag: string;
   enumTag: number;
}
